import React from "react";
import { connect } from "react-redux";

import { getPaymentByID, isPaymentExpanded, getGoToPaymentID } from "state/school_money/selectors";
import { setExpandedPayment } from "state/school_money/actions";

import ExpandingBox from "components/ExpandingBox";
import Card from "components/Card";
import Highlight from "components/Highlight";
import PaymentHeader from "components/school_money/payments/PaymentHeader";
import OfflineOnlyPaymentBody from "components/school_money/payments/OfflineOnlyPaymentBody";
import PaymentInstallmentList from "components/school_money/payments/PaymentInstallmentList";

import "./Payment.css";

class Payment extends React.Component {

  hasMultipleInstallments() {
    return this.props.payment.get("installments").size > 1;
  }

  expand = () => {
    this.props.setExpandedPayment(this.props.paymentID);
  }
  collapse = () => {
    this.props.setExpandedPayment(null);
  }

  getlimitedPlacesIndicator() {
    const { hasLimitedPlaces } = this.props.payment.toObject();
    return hasLimitedPlaces ? <div className="payment__limited-places">Limited Places</div> : null;
  }

  renderOfflineOnlyPayment() {
    const { paymentID, isExpanded } = this.props;
    return (
      <ExpandingBox cssModifier="school_money" expanded={isExpanded} onExpand={this.expand} onCollapse={this.collapse}>
        <ExpandingBox.Header toggleOnClick={true}>
          <PaymentHeader paymentID={paymentID} />
        </ExpandingBox.Header>
        <ExpandingBox.Body toggleOnClick={false}>
          <OfflineOnlyPaymentBody paymentID={paymentID} />
          { this.getlimitedPlacesIndicator() }
        </ExpandingBox.Body>
      </ExpandingBox>
    );
  }

  renderExpandingPayment() {
    const { paymentID, payment, isExpanded } = this.props;
    const installmentNumberList = payment.get("installments").keySeq().toArray();
    return (
      <ExpandingBox cssModifier="school_money" expanded={isExpanded} onExpand={this.expand} onCollapse={this.collapse}>
        <ExpandingBox.Header>
          <PaymentHeader paymentID={paymentID} />
        </ExpandingBox.Header>
        <ExpandingBox.Body>
          <PaymentInstallmentList
            paymentID={paymentID}
            installmentNumberList={installmentNumberList}
            showAddRemoveButtons={this.hasMultipleInstallments()}
          />
          { this.getlimitedPlacesIndicator() }
        </ExpandingBox.Body>
      </ExpandingBox>
    )
  }

  renderSimplePayment() {
    return (
      <Card className="payment">
        <Card.Body>
          <PaymentHeader
            paymentID={this.props.paymentID}
            limitedPlacesIndicator={this.getlimitedPlacesIndicator()}
          />
        </Card.Body>
      </Card>
    )
  }

  render() {

    const { isOfflineOnly, isPartial, isVoluntary } = this.props.payment.toObject();
    const hasMultipleInstallments = this.hasMultipleInstallments();

    let innerChild;
    if (isOfflineOnly) {
      innerChild = this.renderOfflineOnlyPayment();
    } else if (hasMultipleInstallments || isVoluntary || isPartial) {
      innerChild = this.renderExpandingPayment();
    } else {
      innerChild = this.renderSimplePayment();
    }

    return (
      <div ref={this.props.innerRef}>
        <Highlight cssModifier="school_money" isHighlighted={this.props.isHighlighted}>
          { innerChild }
        </Highlight>
      </div>
    )

  }

}

export default connect(
  (state, { paymentID }) => ({
    payment: getPaymentByID(state, paymentID),
    isExpanded: isPaymentExpanded(state, paymentID),
    isHighlighted: paymentID === getGoToPaymentID(state)
  }),
  { setExpandedPayment }
)(Payment);



// WEBPACK FOOTER //
// ./src/components/school_money/payments/Payment.js